import React from 'react';
import { connect } from "react-redux";
import Loader from '../../Global/loader';
import './main.scss';
import Layout from './Layout/Layout'
import { requireAuthentication } from './../../Global/requireAuthentication'
import logout from './../../Global/logout'

export class UserMain extends React.Component{

    state={
        //error: false,
        loading: true,
        userName: "",
        password: ""
    }

    componentDidMount = async() => {
        if(this.props.role === "admin"){
            logout()            
        }
        else{
            this.setState({
                loading: false
            })
        }
    }

    render(){  
        const {loading} = this.state
        
        
    return(    
        <main className="" role="main">
            {loading ?
                <Loader/>                                   
            :                
                <Layout /> 
            }  
        </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        role: state.user.role
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(requireAuthentication(UserMain));
